import { Box, ListItem, ListItemText, Typography, styled } from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Circle, CheckCircle } from '@phosphor-icons/react';

export const ToDoListStyled = styled(Box)(({ theme }) => ({
  padding: `${theme.spacing(10)} ${theme.spacing(9)}`,
  backgroundColor: '#FFFFFF',
  borderRadius: '0.4rem',
  boxShadow: '0px 1px 10px 0px #0000003D',
}));

export const HeaderContainerStyled = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
});

export const ToDoListHeaderStyled = styled(Typography)(({ theme }) => ({
  fontSize: '2.3rem',
  fontWeight: '600',
  marginBottom: theme.spacing(2.5),
}));

export const ToDoListDescriptionStyled = styled(Typography)({
  fontSize: '1.6rem',
});

export const CounterWrapperStyled = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: '4px',
});

export const ToDoListItem = styled(ListItem)(({ theme }) => ({
  marginTop: theme.spacing(2.5),
  border: `0.1rem solid ${theme.palette.grey[200]}`,
  borderRadius: '0.4rem',
  padding: theme.spacing(2.5),
  color: theme.palette.primaryDark.main,
  fontSize: '1.6rem',
}));

export const ListItemNavigateIconStyled = styled(ChevronRightIcon)(
  ({ theme }) => ({
    color: theme.palette.primaryDark.main,
  })
);

export const ListItemCircleIconStyled = styled(Circle)(({ theme }) => ({
  color: theme.palette.primaryDark.main,
  fontSize: '3.2rem',
}));

export const ListItemCheckCircleIconStyled = styled(CheckCircle)(
  ({ theme }) => ({
    color: theme.palette.success.main,
    fontSize: '3.2rem',
  })
);

export const ListItemTextStyled = styled(ListItemText)(({ theme }) => ({
  '& .MuiListItemText-primary': {
    display: 'flex',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
}));

export const DueDateStyled = styled(Typography)(({ theme }) => ({
  border: `1px solid ${theme.palette.warning.main}`,
  borderRadius: '0.4rem',
  backgroundColor: '#FFDBA2',
  fontSize: '1rem',
  padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
  [theme.breakpoints.down('sm')]: {
    marginTop: theme.spacing(2.5),
  },
}));
